/* eslint-disable import/no-anonymous-default-export */

import { useContext, useCallback } from 'react';
import _map from 'lodash/map';

import { RoleDocument, User } from 'commons/models/marketingDashboard';
import { formatListData, AjaxContext } from 'commons-ui';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	// dont pass the app name in case of users as we want to make the call to ludosupreme irrespectivbe of the app selected

	const getUsersData = useCallback(
		async ({
			app,
			pageDetails,
			sortDetails,
			filterDetails
		}: {
			app: any;
			pageDetails: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const res = await postData({
				endpoint: '/marketing/dashboard/user/listUsers',
				body: {
					filters: filterDetails,
					sortInfoArray: sortDetails,
					page: pageDetails
				},
				queryParams: {
					appName: app.appName
				}
			});
			const listData = formatListData(res?.data?.users);
			return { rowCount: res?.data?.userCount, data: listData };
		},
		[]
	);

	const requestUpdateUser = useCallback((appName: string, data: User) => {
		return postData({
			endpoint: '/marketing/dashboard/user/editUser',
			body: { ...data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestCreateUser = useCallback((appName: string, data: User) => {
		return postData({
			endpoint: '/marketing/dashboard/user/createUser',
			body: { ...data },
			queryParams: {
				appName
			}
		});
	}, []);

	const getRoleOptions = useCallback(async ({ app }: { app: any }) => {
		const res = await postData({
			endpoint: '/marketing/dashboard/role/getRoles',
			body: {},
			queryParams: {
				appName: app.appName
			}
		});
		const listData = res?.data?.roles;
		const formattedListData = _map(listData, (role: RoleDocument) => ({
			id: role._id,
			label: role.role
		}));
		return formattedListData;
	}, []);

	return {
		getUsersData,
		requestUpdateUser,
		requestCreateUser,
		getRoleOptions
	};
};

export default useService;
